import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { TabProvider } from "./tabContext";
export const Group = ({ children, value, color = "blue050", size = "medium" }) => {
    return (_jsx(TabProvider, { value: value, color: color, size: size, children: children }));
};
//# sourceMappingURL=Group.js.map